/*//////////////////////*/
/* Imports
/*/ /////////////////////*/
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getContentReducer } from "../../store/content/content.selector";
import { getHistoryReducer } from "../../store/history/history.selector";
import {
  getProjects,
  getProjectsReducer,
  getVideos,
  getScales
} from "../../store/projects/projects.selector";
import {
  setSocketsAutoPlay,
  setSocketsAutoStop,
  setSocketsLogoURL,
  setSocketsNewScaleReady,
  setSocketsNewImages
} from "../../utils/websockets.utils";
import BackButton from "../../components/BackButton/BackButton.component";
import Element from "../../components/Element/Element.component";
import Empty from "../../components/Empty/Empty.component";
import { useEffect, useMemo, useState, useRef } from "react";
import { setLastPage } from "../../store/history/history.reducer";
import { PlayPause } from "../../icons/PlayPause.icon";
import { getAuthReducer } from "../../store/auth/auth.selector";
import SearchButton from "../../components/SearchButton/SearchButton.component";
import Loader from "../../components/Loader/Loader.component";
import {
  getAutoplayVideos,
  getMinutesFromSeconds,
  getPlan,
  getProjectsRoutes,
  getScale,
  getScaleVideos,
} from "../../utils/helpers.utils";
import "./Videos.styles.scss";
import {
  setCurrentProject,
  setCurrentScale,
} from "../../store/projects/projects.reducer";

const Videos = ({ socket }) => {
  /*//////////////////////*/
  /* Variables
  /*/ /////////////////////*/
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectID, scaleID } = useParams();
  const {
    texts: { textVideos, videosEmpty, videoEmpty },
  } = useSelector(getContentReducer);
  const { singleProject, socketID, logoUrl } = useSelector(getAuthReducer);
  const { loading, currentScale, currentProject } =
    useSelector(getProjectsReducer);
  const projectsReducer = useSelector(getProjectsReducer);
  const projects = useSelector(getProjects);
  const videosRoutes = useSelector(getVideos);
  /* states et refs */
  const [isPlaying, setIsPlaying] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [error, isError] = useState(false);
  const tactilePauseRef = useRef(false);
  const [isUniqueScale, setIsUniqueScale] = useState(false);
  const [isUniqueScaleMultipleProjects, setIsUniqueScaleMultipleProjects] =
    useState(false);
  const scales = useSelector(getScales(projectID));
  const is360 = projects[0]?.isRotative;
  const [currentTime, setCurrentTime] = useState(0)
  const interval = useRef();
  const { lastPage } = useSelector(getHistoryReducer);

  
  /* funct */
  const startInterval = () => {
    interval.current = setInterval(() => {
      setCurrentTime(t => t + 1)
    }, 1000)
  }

  const clearTheInterval = () => {
    clearInterval(interval.current)
    interval.current = null
  }

  /* memos */
  const plan = useMemo(
    () => getPlan(projectsReducer, projectID),
    [projectID, projectsReducer]
  );
  const autoplayVideos = useMemo(
    () => getAutoplayVideos(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const videos = useMemo(
    () => getScaleVideos(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const scale = useMemo(
    () => getScale(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const projectsRoutes = useMemo(
    () => getProjectsRoutes(projects, videosRoutes),
    [projects, videosRoutes]
  );
  

  const otherScale = scales.filter(s => s.id !== scale.id)[0]

  /*//////////////////////*/
  /* Effects
  /*/ /////////////////////*/

  /* update scale et lancement vidéo correspondante */
  useEffect(() => {

  }, [])

  useEffect(() => {
    if (currentScale !== scaleID || currentProject !== projectID) {
      dispatch(setCurrentScale(scaleID));
      dispatch(setCurrentProject(projectID));
      if (scale.isReadyVideo && socketID) {
        if (!is360) { // Pas de lancement pour les 360
          setSocketsNewScaleReady(scale.isReadyVideo, socketID);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scaleID, projectID, currentScale, socketID]);

  useEffect(() => {
    dispatch(setLastPage("videos"));
    if (socket) {
      socket.on("videoRemote", videoRemote);
      socket.on("autoPlayNewVideo", autoPlayNewVideo);
      socket.on("tactileTouch", tactilePause);
    }
    return () => {
      if (socket) {
        socket.off("videoRemote", videoRemote);
        socket.off("autoPlayNewVideo", autoPlayNewVideo);
        socket.off("tactileTouch", tactilePause);
        socket.emit("autoStop", socketID);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  // useEffect(() => {
  //   // Lancement automatique des videos à l'arrivé sur la page scale pour eviter l'ecran noir
  //   if (lastPage === "scales") {
  //     onAutoPlay();
  //   }
  // }, [lastPage])

  useEffect(() => {
    if (socket) {
      if (isPlaying === true) {
        if (autoplayVideos.length > 0) {
          setSelectedVideo(autoplayVideos[0].id);
          setSocketsAutoPlay(
            autoplayVideos.map((autoplayVideo) => {
              if (
                autoplayVideo.type === "Player" &&
                autoplayVideo.auto === true
              ) {
                return { id: autoplayVideo.id, file: autoplayVideo.file };
              } else {
                return null;
              }
            }),
            socketID
          );
        }
      } else if (!tactilePauseRef.current) {
        setSelectedVideo(null);
        setSocketsAutoStop(socketID);
        if (!scale.useLogoForBackground) {
          setSocketsNewImages([scale.searchBackgroundImage], null, socketID)
        }
      } else {
        tactilePauseRef.current = false;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying]);

  /* récupération de l'avatar */

  useEffect(() => {
    if (projects[0].idleTimeout !== 0) {
      if (currentTime >= projects[0].idleTimeout) {
        if (is360) { navigate("/") }
        else {
          onAutoPlay();
        }
      }
    }
  }, [currentTime]);

  useEffect(() => {


    // Affichage du logo ou image fixe --- TEMP --- passer en standard si image ajouté
    if (socket && socketID) {
      //
      if (is360 && scale.searchBackgroundImage) {
        setSocketsNewImages([scale.searchBackgroundImage], null, socketID)
      } else if (scale.useLogoForBackground) {
        if (logoUrl) {
          setSocketsLogoURL(process.env.REACT_APP_STRAPI + logoUrl, socketID);
        }
      } else if (scale.searchBackgroundImage) {
        setSocketsNewImages([scale.searchBackgroundImage], null, socketID)
      }

      // 
      if (projects[0].idleTimeout !== 0 && autoplayVideos && autoplayVideos.length > 1) {
        startInterval()
      }

  
    }

    return () => {
      clearTheInterval()
    }
  }, [logoUrl, socket, socketID]);

  /* verification si une seule échelle */
  useEffect(() => {
    if (singleProject) {
      const currentProject = projectsRoutes.find(
        (project) => project.id === +projectID
      );
      if (
        currentProject?.scales &&
        currentProject.scales.length === 1 &&
        !plan
      ) {
        if (projectsRoutes?.length === 1) {
          setIsUniqueScale(true);
        } else {
          setIsUniqueScaleMultipleProjects(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectsRoutes, singleProject, projectID, scaleID]);

  /*//////////////////////*/
  /* Functions
  /*/ /////////////////////*/
  const totalAutoplayTime = useMemo(() => {
    const total = videos.reduce(
      (total, video) =>
        video.auto && video?.videoDuration
          ? total + video.videoDuration
          : total,
      0
    );
    return total && total > 0 ? getMinutesFromSeconds(total) : null;
  }, [videos]);

  const onAutoPlay = () => {
    setIsPlaying(p => {
      if (!p) {
        clearTheInterval()
        setCurrentTime(0)
      } else {
        startInterval()
      }
      return !p
    });
  };

  const autoPlayNewVideo = (videoId) => {
    setSelectedVideo(videoId);
  };

  const videoRemote = ({ exists, total }) => {
    isError(exists ? false : true);
    if (!exists) {
      setSelectedVideo(null);
    }
  };

  const tactilePause = () => {
    console.log('tactile: stopping frontend playback');
    tactilePauseRef.current = true;
    setIsPlaying(false);
    setSelectedVideo(null);
    clearTheInterval();
    setCurrentTime(0);
  };

  /*//////////////////////*/
  /* Return
  /*/ /////////////////////*/

  return (
    <>
      <BackButton
        text={textVideos}
        link={isUniqueScaleMultipleProjects ? "/" : `/project/${projectID}${window?.location?.search}`}
        back={!isUniqueScale}
      />
      {autoplayVideos && autoplayVideos.length > 1 && (
        <>
          {error ? (
            <Empty text={videoEmpty} />
          ) : (
            <header className="autoplay relative flex justify-center rounded-md p-6 mb-8">
              <hr className="absolute inset-0 h-full w-full bg-light-primary rounded-md" />
              <button onClick={onAutoPlay} className="relative">
                <PlayPause isPlaying={isPlaying} autoPlayIcon />
              </button>
              {totalAutoplayTime && (
                <span className="autoplay__total | text-primary">
                  {totalAutoplayTime}
                </span>
              )}
            </header>
          )}
        </>
      )}
      {loading ? (
        <div className="relative h-56">
          <Loader />
        </div>
      ) : (
        <>
          {videos && videos.length ? (
            <ul>
              {videos.map((video) => {
                return (
                  !video.onlyAuto && (
                    <li key={video.id}>
                      <Element
                        text={video.name}
                        link={`video/${video.id}${window?.location?.search}`}
                        selected={selectedVideo === video.id ? true : false}
                        autoPlay={
                          video.auto && autoplayVideos.length > 1 ? true : false
                        }
                        duration={video.videoDuration}
                      />
                    </li>
                  )
                );
              })}

              {is360 &&
                <li>
                  <Element 
                    text={otherScale.name}
                    link={`/project/${projectID}/rotation/${otherScale.id}${window?.location?.search}`}
                    icon={otherScale.icon}
                  />
                </li>
              }

            </ul>
          ) : (
            !scale?.search && (
              <li>
                <Empty text={videosEmpty} />
              </li>
            )
          )}

          {scale?.search && (
            <SearchButton projectID={projectID} scaleID={scaleID} />
          )}
        </>
      )}
    </>
  );
};

export default Videos;
